import React, { useEffect, useState } from "react";
import { Column } from "devextreme-react/data-grid";
import { LVGridCabecera } from "../../../../Componentes/Basicos/LVGridCabecera";
import { PaginaListadoMaestros } from "../../../../Componentes/Compuestos/Paginas/PaginaListadoMaestros";
import { NumberBox } from "devextreme-react";

export const ABM_Reporte_EEX_Clientes_Cumpleanos = () => {
  const [data, setData] = useState([])
  const [mes, setMes] = useState(1)
  const { ABM_EEX_Clientes: { function_ABM_EEX_Clientes_ListarDeReservasParaMarketing } } = require('neftis7_apicaller');

  const handleDataLoaded = (data) => {
    setData(data);
  };

  const getData = async () => {
    try {
      const response = await function_ABM_EEX_Clientes_ListarDeReservasParaMarketing(" AND MONTH(cl.FechaNacimiento) = " + mes);
      setData(response.data);
    } catch (error) {
      alert("Error al cargar los datos:" + error);
    }
  };

  useEffect(() => {
    getData();
  }, [mes]);

  return (
    <PaginaListadoMaestros
      Titulo="CUMPLEAÑOS DE CLIENTES"
      funcion={function_ABM_EEX_Clientes_ListarDeReservasParaMarketing}
      parametroExtra1={" AND MONTH(cl.FechaNacimiento) = " + mes}
      onDataLoaded={handleDataLoaded}
    >
      <div className="table-responsive">
        <div style={{ display: 'flex', alignItems: 'left', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>
          <NumberBox text="Mes" value={mes} min={1} max={12} width={100} onValueChanged={(e) => setMes(e.value)} />
        </div>
        {data.length > 0 ? (
          <LVGridCabecera
            dataSource={data}
            id="gridContainer"
            AnchoBotonera="65"
          >
            <Column caption="Autorizado" dataField="Autorizado" width="100%" minWidth="200" alignment="Left" dataType="string" />
            <Column caption="F. Nacimiento" dataField="FechaNacimiento" width="120" alignment="Right" dataType="date" format={'dd/MM/yyyy'} />
            <Column caption="Responsable" dataField="Responsable" width="100%" minWidth="200" alignment="Left" dataType="string" />
            <Column caption="E-Mail" dataField="Email" width="200" alignment="Left" dataType="string" />
            <Column caption="Teléfono" dataField="telefono" width="200" alignment="Left" dataType="string" />
          </LVGridCabecera>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListadoMaestros>
  );
};
